/**
 * paintFighterBuffCues — 2D stack/empower rings for fighter painters (SPY-112).
 */
import { getFighterBuffReadability } from '../../../domain/champions/fighterBuffReadability.js';

export function paintFighterBuffCues(ctx, radius, entity) {
  const r = getFighterBuffReadability(entity);
  if (!r || (r.stacks <= 0 && r.fill <= 0 && !r.empowered)) return;
  const pipN = r.passiveId === 'pit_grit'
    ? Math.max(0, Math.round(r.fill * 5))
    : Math.min(r.maxStacks || 0, r.stacks || 0);
  const color = r.passiveId === 'hemorrhage'
    ? '#ef4444'
    : (r.passiveId === 'pit_grit' ? '#fb923c' : '#c084fc');
  if (r.empowered) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 1.25, 0, Math.PI * 2);
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(2, radius * 0.12);
    ctx.stroke();
  }
  for (let i = 0; i < pipN; i += 1) {
    const a = -Math.PI / 2 + (i / Math.max(1, pipN)) * Math.PI * 2;
    const x = Math.cos(a) * radius * 1.05;
    const y = Math.sin(a) * radius * 1.05;
    ctx.beginPath();
    ctx.arc(x, y, radius * 0.14, 0, Math.PI * 2);
    ctx.fillStyle = color;
    ctx.fill();
  }
}
